import { addMixpanelEvent } from "./mixpanelLogger";

export const openBookADemo = () => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const width = 400;
  const height = 625;
  const left = (screenWidth - width) / 2;
  const top = (screenHeight - height) / 0.8;
  const hubspotUrl =
    "https://meetings.hubspot.com/jobin-johny/deskday-demo-meet";
  window.open(
    hubspotUrl,
    "BookADemo",
    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
  );
  addMixpanelEvent({
    event: "book_a_demo_clicked",
  });
};
